export class TypeMismatchError {
    expected;
    actual;
    steps;
    constructor(expected, actual = undefined, steps = []) {
        this.expected = expected;
        this.actual = actual;
        this.steps = steps;
    }
    get path() {
        return this.steps.reduce((path, step) => {
            if (typeof step === 'string') {
                if (path) {
                    return `${path}.${step}`;
                }
                return step;
            }
            return `${path}[${step}]`;
        }, '');
    }
    get message() {
        let message;
        if (this.expected) {
            message = `Expected ${this.expected}`;
            if (this.actual) {
                message += `, but found ${this.actual}`;
            }
        }
        else {
            message = `Unexpected ${this.actual}`;
        }
        if (this.steps.length) {
            message += `, at path '${this.path}'`;
        }
        return message;
    }
    /**
     * @internal
     *
     * @param step
     * @param fn
     * @returns
     */
    static hoist(step, fn) {
        if (!Array.isArray(step)) {
            // eslint-disable-next-line no-param-reassign
            step = [step];
        }
        try {
            return fn();
        }
        catch (err) {
            if (err instanceof TypeMismatchError) {
                // eslint-disable-next-line no-ex-assign
                err = new TypeMismatchError(err.expected, err.actual, [...step, ...err.steps]);
            }
            throw err;
        }
    }
}
//# sourceMappingURL=error.js.map